import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component BudgetAlertIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <BudgetAlertIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <BudgetAlertIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const BudgetAlertIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="BudgetAlertIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="nonzero"
        d="M14 17v1h-4v-1zM13 5l.001 1.1A5 5 0 0 1 17 11v5H7v-5a5 5 0 0 1 4-4.9V5zm-1 2a4 4 0 0 0-3.995 3.8L8 11v4h8v-4a4 4 0 0 0-3.8-3.995z"
      />
    </svg>
  )
);
BudgetAlertIcon.displayName = "BudgetAlertIcon";
export default BudgetAlertIcon;
